import styled from 'styled-components'

export const Text = styled.span`
  color: ${props => props.theme.colors.brand.gray90};
  font-size: ${props => props.theme.font.sizes.sm};
`
